<template>
    <transition
        v-if="showBanner"
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    >
        <div class="shadow-action font-semibold text-lg bg-action rounded text-white p-3 mb-4" :class="{ 'fixed top-4 right-0 max-w-xs': floating }">
            <div class="flex items-center">
                <div class="flex-shrink-0">
                    <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="color: yellow;">
                        <path d="M12 3L22 20H2L12 3Z" fill="currentColor"/>
                        <path d="M12 10V14" stroke="#333" stroke-width="2" stroke-linecap="round"/>
                        <circle cx="12" cy="17" r="1" fill="#333"/>
                    </svg>
                </div>
                <div class="ml-3">
                    <p class="text-sm font-medium">Signing up through VPN can impact your chances of approval</p>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import axios from 'axios';

export default {
    name: 'VpnWarningBanner',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        floating: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isVpnDetected: false
        };
    },
    computed: {
        showBanner() {
            return this.show || this.isVpnDetected || (this.$store && this.$store.getters && this.$store.getters.vpnDetected);
        }
    },
    mounted() { 
    },
    methods: {
    }
}
</script> 